
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-accent">
      <div className="text-center max-w-md px-4">
        <h1 className="text-6xl font-bold text-nepal-red">404</h1>
        <p className="text-xl text-gray-700 mb-8 mt-2">
          We couldn't find the page you're looking for
        </p>
        <Link to="/">
          <Button className="flex items-center">
            <ArrowLeft size={16} className="mr-2" />
            Back to Promise Tracker
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
